module.exports = __webpack_public_path__ + "static/media/fedEx.17bf37d6.png";